export const BLACK_COLOR = "#1b1b1b"
export const GREY_COLOR = "#767676"
export const PRIMARY_COLOR_100 = "#243582"
export const WHITE_COLOR = "#fff"
